import { useState } from "react";
import { Linkedin, Facebook, Link2, Check } from "lucide-react";

const SITE_URL = "https://wexoz.com";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16 3C8.8 3 3 8.8 3 16c0 2.3.6 4.5 1.8 6.5L3 29l6.7-1.8c1.9 1 4.1 1.6 6.3 1.6 7.2 0 13-5.8 13-13S23.2 3 16 3zm0 23.6c-2 0-3.9-.5-5.6-1.5l-.4-.2-4 1.1 1.1-3.9-.3-.4A10.5 10.5 0 0 1 5.4 16C5.4 10.2 10.2 5.4 16 5.4S26.6 10.2 26.6 16 21.8 26.6 16 26.6zm5.8-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.6-.9-.8-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-1-2.3c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.2 2.4 3.6 5.8 5.1.8.3 1.4.6 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.8.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z" />
  </svg>
);

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true"><path d="M18.9 2H22l-7.6 8.7L23 22h-6.8l-5.3-6.9L4.8 22H1.7l8.1-9.3L0 2h7l4.8 6.3L18.9 2zm-1.2 18h1.9L7.1 3.9H5.1L17.7 20z" /></svg>
);

const btn = "inline-flex h-10 items-center gap-2 rounded-full border border-line px-4 text-sm font-medium text-slate-200 transition-[border-color,color,transform] duration-200 hover:-translate-y-0.5 hover:border-cyan-400/60 hover:text-white";

export const ShareBar = ({ title, slug, compact = false }) => {
  const [copied, setCopied] = useState(false);
  const url = `${SITE_URL}/insights/${slug}`;
  const enc = encodeURIComponent;
  const targets = [
    { name: "LinkedIn", Icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}` },
    { name: "Facebook", Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { name: "X", Icon: XIcon, href: `https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(title)}` },
    { name: "WhatsApp", Icon: WhatsAppIcon, href: `https://wa.me/?text=${enc(`${title}\n${url}`)}` },
  ];

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); } catch { /* clipboard unavailable */ }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div data-testid="share-bar" className="flex flex-wrap items-center gap-2">
      {!compact && <span className="mr-2 font-mono text-[11px] uppercase tracking-wider text-slate-500">Share</span>}
      {targets.map(({ name, Icon, href }) => (
        <a key={name} href={href} target="_blank" rel="noopener noreferrer" data-testid={`share-${name.toLowerCase()}`} className={btn} aria-label={`Share on ${name}`}>
          <Icon className="h-4 w-4" /> {name}
        </a>
      ))}
      <button type="button" onClick={copy} data-testid="share-copy-link" className={btn} aria-label="Copy link">
        {copied ? <Check className="h-4 w-4 text-cyan-400" /> : <Link2 className="h-4 w-4" />} {copied ? "Copied" : "Copy link"}
      </button>
    </div>
  );
};
